import { render, staticRenderFns } from "./AppListGroup.vue?vue&type=template&id=2e064176&scoped=true"
import script from "./AppListGroup.vue?vue&type=script&lang=js"
export * from "./AppListGroup.vue?vue&type=script&lang=js"
import style0 from "./AppListGroup.vue?vue&type=style&index=0&id=2e064176&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e064176",
  null
  
)

export default component.exports